module.exports = { 
    AUTHORIZATION_CHECK: Object.freeze({
        AUTHORIZED: 1,
        NOT_AUTHORIZED: 2,
        NO_MATER: 3,
    }),

    CHECK_NEW_CLIENT: Object.freeze({
        FOR_NEW: 1,
        NOT_NEW: 2,
        NO_MATER: 3,
    }),
};